module.exports = "<chassis-nova-datatable\n    [resource]=\"entityName\"\n></chassis-nova-datatable>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/resources/pages/index/index.page.html
// module id = ./libs/chassis-core/src/app/resources/pages/index/index.page.html
// module chunks = main